module.exports = "connect-blocks"